import { createAction, props } from '@ngrx/store';

export namespace NoteActions {
  export enum Type {
    ADD_NOTE = '[NOTE] Add Note',
    ADD_NOTE_SUCCESS = '[NOTE] Add Note Success',
    ADD_NOTE_ERROR = '[NOTE] Add Note Error',
    DELETE_NOTE = '[NOTE] Delete Note',
    DELETE_NOTE_SUCCESS = '[NOTE] Delete Note Success',
    DELETE_NOTE_ERROR = '[NOTE] Delete Note Error',
    GET_NOTE = '[NOTE] Get Note',
    GET_NOTE_SUCCESS = '[NOTE] Get Note Success',
    GET_NOTE_ERROR = '[NOTE] Get Note Error',
  }

  export const addNote = createAction(
    Type.ADD_NOTE,
    props<{ note: string; installationId: string }>()
  );

  export const addNoteSuccess = createAction(Type.ADD_NOTE_SUCCESS);

  export const addNoteError = createAction(Type.ADD_NOTE_ERROR, props<{ error: any }>());

  export const deleteNote = createAction(Type.DELETE_NOTE, props<{ installationId: string }>());

  export const deleteNoteSuccess = createAction(Type.DELETE_NOTE_SUCCESS);

  export const deleteNoteError = createAction(Type.DELETE_NOTE_ERROR, props<{ error: any }>());

  export const getNote = createAction(Type.GET_NOTE, props<{ installationId: string }>());

  export const getNoteSuccess = createAction(Type.GET_NOTE_SUCCESS, props<{ note: string }>());

  export const getNoteError = createAction(Type.GET_NOTE_ERROR, props<{ error: any }>());
}
